import { ParentInfo, ParentDetails } from 'src/app/application/models/parent-guardian-details';
import { Address } from '../address/address.model';
import { PersonDetails } from '../person-details/person-details.model';
import { PhoneNumberDetails } from '../phone-number/phone-number.model';
import { VisaOshc } from '../../models/visa-ohsc';
import { SchoolProgramPlacementDetails } from '../../models/school-program-placement-details';
import { AccommodationWelfareUpdateDetails } from '../../models/accommodation-welfare-details';
import { EnglishProficiencyDetails } from '../../models/english-proficiency-details';
import { SpecialCircumstances } from '../../models/special-circumstances';
import { DefaultCorrespondent } from '../../models/corresondents';
import { ApplicationAgentDetails } from '../../models/application-agent-details';


export const compareAddresses = (initialAddress: Address, currentAddress: Address): boolean => {
    return initialAddress.line1 === currentAddress.line1 &&
            initialAddress.line2 === currentAddress.line2 &&
            initialAddress.postcode === currentAddress.postcode &&
            initialAddress.state === currentAddress.state &&
            initialAddress.suburb === currentAddress.suburb &&
            initialAddress.country === currentAddress.country &&
            initialAddress.isCurrentAddress === currentAddress.isCurrentAddress;
};

export const comparePersonDetails = (initialPersonDetails: PersonDetails, currentPersonDetails: PersonDetails): boolean => {
    return initialPersonDetails.relationship === currentPersonDetails.relationship &&
            initialPersonDetails.givenName === currentPersonDetails.givenName &&
            initialPersonDetails.familyName === currentPersonDetails.familyName &&
            initialPersonDetails.preferredName === currentPersonDetails.preferredName &&
            initialPersonDetails.gender === currentPersonDetails.gender &&
            initialPersonDetails.nationality === currentPersonDetails.nationality &&
            initialPersonDetails.countryOfBirth === currentPersonDetails.countryOfBirth &&
            initialPersonDetails.dateOfBirth === currentPersonDetails.dateOfBirth &&
            initialPersonDetails.passportNumber === currentPersonDetails.passportNumber &&
            initialPersonDetails.emailAddress === currentPersonDetails.emailAddress;
};

export const compareStudentPersonDetails = (initialPersonDetails: PersonDetails, currentPersonDetails: PersonDetails): boolean => {
    return  initialPersonDetails.givenName === currentPersonDetails.givenName &&
            initialPersonDetails.familyName === currentPersonDetails.familyName &&
            initialPersonDetails.preferredName === currentPersonDetails.preferredName &&
            initialPersonDetails.gender === currentPersonDetails.gender &&
            initialPersonDetails.nationality === currentPersonDetails.nationality &&
            initialPersonDetails.countryOfBirth === currentPersonDetails.countryOfBirth &&
            initialPersonDetails.dateOfBirth === currentPersonDetails.dateOfBirth &&
            initialPersonDetails.passportNumber === currentPersonDetails.passportNumber &&
            initialPersonDetails.emailAddress === currentPersonDetails.emailAddress;
};

export const compareParentGuardianPersonDetails = (initialPersonDetails: PersonDetails, currentPersonDetails: PersonDetails): boolean => {
    return  initialPersonDetails.relationship === currentPersonDetails.relationship &&
            initialPersonDetails.givenName === currentPersonDetails.givenName &&
            initialPersonDetails.familyName === currentPersonDetails.familyName &&
            initialPersonDetails.preferredName === currentPersonDetails.preferredName &&
            initialPersonDetails.gender === currentPersonDetails.gender &&
            initialPersonDetails.nationality === currentPersonDetails.nationality &&
            initialPersonDetails.countryOfBirth === currentPersonDetails.countryOfBirth &&
            initialPersonDetails.dateOfBirth === currentPersonDetails.dateOfBirth &&
            initialPersonDetails.passportNumber === currentPersonDetails.passportNumber &&
            initialPersonDetails.emailAddress === currentPersonDetails.emailAddress;
};


export const comparePhoneNumberDetails =
    (initialPhoneNumberDetails: PhoneNumberDetails, currentPhoneNumberDetails: PhoneNumberDetails): boolean => {
        return initialPhoneNumberDetails.homeCountryCode === currentPhoneNumberDetails.homeCountryCode &&
            initialPhoneNumberDetails.homePhoneNumber === currentPhoneNumberDetails.homePhoneNumber &&
            initialPhoneNumberDetails.mobileCountryCode === currentPhoneNumberDetails.mobileCountryCode &&
            initialPhoneNumberDetails.mobilePhoneNumber === currentPhoneNumberDetails.mobilePhoneNumber;
};

export const compareStudentDetails = (initialPersonDetails: PersonDetails, currentPersonDetails: PersonDetails,
         initialPhoneNumberDetails: PhoneNumberDetails, currentPhoneNumberDetails: PhoneNumberDetails,
         initialAustralianAddress: Address, currentAustralianAddress: Address,
         initialOverseasAddress: Address, currentOverseasAddress: Address): boolean => {

            const initPersonDetails = {...initialPersonDetails};
            const crntPersonDetails = {...currentPersonDetails};
            const initPhoneNumberDetails = { ...initialPhoneNumberDetails };
            const crntPhoneNumberDetails = { ...currentPhoneNumberDetails };
            const initAustralianAddress = {...initialAustralianAddress};
            const crntAustralianAddress = {...currentAustralianAddress};
            const initOverseasAddress = {...initialOverseasAddress};
            const crntOverseasAddress = {...currentOverseasAddress};

            updateEmptyValueForNullUndefined(initPersonDetails);
            updateEmptyValueForNullUndefined(crntPersonDetails);
            updateEmptyValueForNullUndefined(initPhoneNumberDetails);
            updateEmptyValueForNullUndefined(crntPhoneNumberDetails);
            updateEmptyValueForNullUndefined(initAustralianAddress);
            updateEmptyValueForNullUndefined(crntAustralianAddress);
            updateEmptyValueForNullUndefined(initOverseasAddress);
            updateEmptyValueForNullUndefined(crntOverseasAddress);

             return compareStudentPersonDetails(initPersonDetails, crntPersonDetails)
                    && comparePhoneNumberDetails(initPhoneNumberDetails, crntPhoneNumberDetails)
                    && compareAddresses(initAustralianAddress, crntAustralianAddress)
                    && compareAddresses(initOverseasAddress, crntOverseasAddress);
         };

export const compareParentGuardianDetails = (initialPersonDetails: PersonDetails, currentPersonDetails: PersonDetails,
initialPhoneNumberDetails: PhoneNumberDetails, currentPhoneNumberDetails: PhoneNumberDetails,
initialAustralianAddress: Address, currentAustralianAddress: Address,
initialOverseasAddress: Address, currentOverseasAddress: Address): boolean => {

    const initPersonDetails = initialPersonDetails === undefined ? undefinedPersonDetails() : {...initialPersonDetails};
    const crntPersonDetails = {...currentPersonDetails};
    const initPhoneNumberDetails = initialPhoneNumberDetails === undefined ?
                                        undefinedPhoneNumberDetails() : { ...initialPhoneNumberDetails };
    const crntPhoneNumberDetails = { ...currentPhoneNumberDetails };
    const initAustralianAddress = initialAustralianAddress === undefined ? undefinedAddress() : {...initialAustralianAddress};
    const crntAustralianAddress = {...currentAustralianAddress};
    const initOverseasAddress = initialOverseasAddress === undefined ? undefinedAddress() : {...initialOverseasAddress};
    const crntOverseasAddress = {...currentOverseasAddress};

    updateEmptyValueForNullUndefined(initPersonDetails);
    updateEmptyValueForNullUndefined(crntPersonDetails);
    updateEmptyValueForNullUndefined(initPhoneNumberDetails);
    updateEmptyValueForNullUndefined(crntPhoneNumberDetails);
    updateEmptyValueForNullUndefined(initAustralianAddress);
    updateEmptyValueForNullUndefined(crntAustralianAddress);
    updateEmptyValueForNullUndefined(initOverseasAddress);
    updateEmptyValueForNullUndefined(crntOverseasAddress);

    return compareParentGuardianPersonDetails(initPersonDetails, crntPersonDetails)
            && comparePhoneNumberDetails(initPhoneNumberDetails, crntPhoneNumberDetails)
            && compareAddresses(initAustralianAddress, crntAustralianAddress)
            && compareAddresses(initOverseasAddress, crntOverseasAddress);
};

export const compareParentLegalcustodianDetails = (
    initialP1ParentInfo: ParentInfo, currentP1ParentInfo: ParentInfo,
    initialP2ParentInfo: ParentInfo, currentP2ParentInfo: ParentInfo,
    initialLCParentInfo: ParentInfo, currentLCParentInfo: ParentInfo,
    initialP1ParentDetails: ParentDetails, currentP1ParentDetails: ParentDetails,
    initialP2ParentDetails: ParentDetails, currentP2ParentDetails: ParentDetails,
    initialLCParentDetails: ParentDetails, currentLCParentDetails: ParentDetails
): boolean => {

    const initP1ParentInfo = initialP1ParentInfo === undefined ? undefinedP1ParentInfo() : {...initialP1ParentInfo};
    const crntP1ParentInfo = {...currentP1ParentInfo};
    const initP2ParentInfo = initialP2ParentInfo === undefined ? undefinedP2ParentInfo() : {...initialP2ParentInfo};
    const crntP2ParentInfo = {...currentP2ParentInfo};
    const initLCParentInfo = initialLCParentInfo === undefined ? undefinedLCParentInfo() : {...initialLCParentInfo};
    const crntLCParentInfo = {...currentLCParentInfo};

    const initP1ParentDetails = initialP1ParentDetails === undefined ? undefinedP1ParentDetails() : {...initialP1ParentDetails};
    const crntP1ParentDetails = {...currentP1ParentDetails};
    const initP2ParentDetails = initialP2ParentDetails === undefined ? undefinedP2ParentDetails() : {...initialP2ParentDetails};
    const crntP2ParentDetails = {...currentP2ParentDetails};
    const initLCParentDetails = initialLCParentDetails === undefined ? undefinedLCParentDetails() : {...initialLCParentDetails};
    const crntLCParentDetails = {...currentLCParentDetails};

    updateEmptyValueForNullUndefined(initP1ParentInfo);
    updateEmptyValueForNullUndefined(crntP1ParentInfo);
    updateEmptyValueForNullUndefined(initP2ParentInfo);
    updateEmptyValueForNullUndefined(crntP2ParentInfo);
    updateEmptyValueForNullUndefined(initLCParentInfo);
    updateEmptyValueForNullUndefined(crntLCParentInfo);
    updateEmptyValueForNullUndefined(initP1ParentDetails);
    updateEmptyValueForNullUndefined(crntP1ParentDetails);
    updateEmptyValueForNullUndefined(initP2ParentDetails);
    updateEmptyValueForNullUndefined(crntP2ParentDetails);
    updateEmptyValueForNullUndefined(initLCParentDetails);
    updateEmptyValueForNullUndefined(crntLCParentDetails);

    // return compareP1ParentInfo(initP1ParentInfo, crntP1ParentInfo)  
    //     && compareP2ParentInfo(initP2ParentInfo, crntP2ParentInfo)  
    //     && compareLCParentInfo(initLCParentInfo, crntLCParentInfo)  
    //     && compareP1ParentDetails(initP1ParentDetails, crntP1ParentDetails)  
    //     && compareP2ParentDetails(initP2ParentDetails, crntP2ParentDetails)  
    //     && compareLCParentDetails(initLCParentDetails, crntLCParentDetails);  
    return false;
}

// export const compareP1ParentInfo = (initP1ParentInfo: ParentInfo, crntP1ParentInfo: ParentInfo): boolean => {
//     return initialPersonDetails.relationship === currentPersonDetails.relationship &&
//             initialPersonDetails.givenName === currentPersonDetails.givenName &&
//             initialPersonDetails.familyName === currentPersonDetails.familyName &&
//             initialPersonDetails.preferredName === currentPersonDetails.preferredName &&
//             initialPersonDetails.gender === currentPersonDetails.gender &&
//             initialPersonDetails.nationality === currentPersonDetails.nationality &&
//             initialPersonDetails.countryOfBirth === currentPersonDetails.countryOfBirth &&
//             initialPersonDetails.dateOfBirth === currentPersonDetails.dateOfBirth &&
//             initialPersonDetails.passportNumber === currentPersonDetails.passportNumber &&
//             initialPersonDetails.emailAddress === currentPersonDetails.emailAddress;
// };

const undefinedP1ParentInfo = (): ParentInfo => ({
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: false,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: false,
    HasLegalCustody: undefined
});
const undefinedP2ParentInfo = (): ParentInfo => ({
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: false,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: false,
    HasLegalCustody: undefined
});
const undefinedLCParentInfo = (): ParentInfo => ({
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: false,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: false,
    HasLegalCustody: undefined
});

const undefinedP1ParentDetails = (): ParentDetails => ({
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    IsAustralianAddress: false,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,
    IsSameAddress: undefined
  });
  const undefinedP2ParentDetails = (): ParentDetails => ({
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    IsAustralianAddress: false,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,
    IsSameAddress: undefined
  });
  const undefinedLCParentDetails = (): ParentDetails => ({
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    IsAustralianAddress: false,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,
    IsSameAddress: undefined
  });

const undefinedPersonDetails = (): PersonDetails => ({
        countryOfBirth: undefined,
        dateOfBirth: undefined,
        emailAddress: undefined,
        familyName: undefined,
        gender: undefined,
        givenName: undefined,
        isRefusedAusVisaBefore: undefined,
        visaRefusalDetails: undefined,
        nationality: undefined,
        onlyHasOneName: undefined,
        hasPassport: undefined,
        passportNumber: undefined,
        passportExpiryDate: undefined,
        preferredName: undefined,
        relationship: undefined,
        otherRelationship: undefined,
    });

const undefinedPhoneNumberDetails = (): PhoneNumberDetails => ({
    homeCountryCode: undefined,
    homePhoneNumber: undefined,
    mobileCountryCode: undefined,
    mobilePhoneNumber: undefined
});

const undefinedAddress = (): Address => ({
   country: undefined,
   isCurrentAddress: undefined,
   line1: undefined,
   line2: undefined,
   postcode: undefined,
   state: undefined,
   suburb: undefined
});



export const compareVisaOHSCDetails = (initialVisaOhsc: VisaOshc, currentVisaOhsc: VisaOshc): boolean => {

    const initVisaOhsc = { ...initialVisaOhsc };
    const crntVisaOhsc = { ...currentVisaOhsc };

    updateEmptyValueForNullUndefined(initVisaOhsc);
    updateEmptyValueForNullUndefined(crntVisaOhsc);

    return initVisaOhsc.HasOshc === crntVisaOhsc.HasOshc
            && initVisaOhsc.HoldsAustralianVisa === crntVisaOhsc.HoldsAustralianVisa
            && initVisaOhsc.IsOnshoreWhileLodgingVisa === crntVisaOhsc.IsOnshoreWhileLodgingVisa
            && initVisaOhsc.OshcExpiryDate === crntVisaOhsc.OshcExpiryDate
            && initVisaOhsc.OshcProviderCode === crntVisaOhsc.OshcProviderCode
            && initVisaOhsc.VisaExpiryDate === crntVisaOhsc.VisaExpiryDate
            && initVisaOhsc.VisaNumber === crntVisaOhsc.VisaNumber
            && initVisaOhsc.VisaSubclassId === crntVisaOhsc.VisaSubclassId
            && initVisaOhsc.IsHealthCoverFromDEInternational === crntVisaOhsc.IsHealthCoverFromDEInternational;
};

export const compareSchoolProgramPlacementDetails = (initialSchoolProgramPlacementDetails: SchoolProgramPlacementDetails,
                                        currentSchoolProgramPlacementDetails: SchoolProgramPlacementDetails): boolean => {

        const initSchoolDetails = { ...initialSchoolProgramPlacementDetails };
        const crntSchoolDetails = { ...currentSchoolProgramPlacementDetails };

        updateEmptyValueForNullUndefined(initSchoolDetails);
        updateEmptyValueForNullUndefined(crntSchoolDetails);

        return initSchoolDetails.AgeInYears === crntSchoolDetails.AgeInYears
                 && initSchoolDetails.AgeInYears === crntSchoolDetails.AgeInYears
                 && initSchoolDetails.CompulsorySubject1Code === crntSchoolDetails.CompulsorySubject1Code
                 && initSchoolDetails.CompulsorySubject2Code === crntSchoolDetails.CompulsorySubject2Code
                 && initSchoolDetails.CompulsorySubject3Code === crntSchoolDetails.CompulsorySubject3Code
                 && initSchoolDetails.CompulsorySubject4Code === crntSchoolDetails.CompulsorySubject4Code
                 && initSchoolDetails.CompulsorySubject5Code === crntSchoolDetails.CompulsorySubject5Code
                 && initSchoolDetails.CompulsorySubject6Code === crntSchoolDetails.CompulsorySubject6Code
                 && initSchoolDetails.CompulsorySubject7Code === crntSchoolDetails.CompulsorySubject7Code
                 && initSchoolDetails.DurationCode === crntSchoolDetails.DurationCode
                 && initSchoolDetails.IecDurationCode === crntSchoolDetails.IecDurationCode
                 && initSchoolDetails.IecStartTermCode === crntSchoolDetails.IecStartTermCode
                 && initSchoolDetails.IecStartTermYear === crntSchoolDetails.IecStartTermYear
                 && initSchoolDetails.IsEligibleForStudyAbroad === crntSchoolDetails.IsEligibleForStudyAbroad
                 && initSchoolDetails.IsSiblingEnrolledInAustralia === crntSchoolDetails.IsSiblingEnrolledInAustralia
                 && initSchoolDetails.PreferredSchool1Id === crntSchoolDetails.PreferredSchool1Id
                 && initSchoolDetails.PreferredSchool2Id === crntSchoolDetails.PreferredSchool2Id
                 && initSchoolDetails.PreferredSchool3Id === crntSchoolDetails.PreferredSchool3Id
                 && initSchoolDetails.SchoolProgramType === crntSchoolDetails.SchoolProgramType
                 && initSchoolDetails.SiblingComments === crntSchoolDetails.SiblingComments
                 && initSchoolDetails.SiblingDateOfBirth === crntSchoolDetails.SiblingDateOfBirth
                 && initSchoolDetails.SiblingFamilyName === crntSchoolDetails.SiblingFamilyName
                 && initSchoolDetails.SiblingGivenName === crntSchoolDetails.SiblingGivenName
                 && initSchoolDetails.SiblingPreferredName === crntSchoolDetails.SiblingPreferredName
                 && initSchoolDetails.SiblingSchoolName === crntSchoolDetails.SiblingSchoolName
                 && initSchoolDetails.SiblingDateOfBirth === crntSchoolDetails.SiblingDateOfBirth
                 && initSchoolDetails.SiblingStudentNumber === crntSchoolDetails.SiblingStudentNumber
                 && initSchoolDetails.StartTermCode === crntSchoolDetails.StartTermCode
                 && initSchoolDetails.StartTermYear === crntSchoolDetails.StartTermYear
                 && initSchoolDetails.WishToEnrolIec === crntSchoolDetails.WishToEnrolIec
                 && initSchoolDetails.YearOfEntryCode === crntSchoolDetails.YearOfEntryCode;
    };


export const compareAccommodationDetails = (initialAccommodationDetails: AccommodationWelfareUpdateDetails,
                                            currentAccommodationDetails: AccommodationWelfareUpdateDetails): boolean => {

    const initAccommodationDetails = { ...initialAccommodationDetails };
    const crntAccommodationDetails = { ...currentAccommodationDetails };

    updateEmptyValueForNullUndefined(initAccommodationDetails);
    updateEmptyValueForNullUndefined(crntAccommodationDetails);

    return initAccommodationDetails.AccommodationTypeId === crntAccommodationDetails.AccommodationTypeId
             && initAccommodationDetails.SelectedCarerId === crntAccommodationDetails.SelectedCarerId;

};

export const compareEnglishProficiencyDetails = (initialEnglishProficiencyDetails: EnglishProficiencyDetails,
                                                currentEnglishProficiencyDetails: EnglishProficiencyDetails): boolean => {

    const initEnglishProficiencyDetails = { ...initialEnglishProficiencyDetails };
    const crntEnglishProficiencyDetails = { ...currentEnglishProficiencyDetails };

    updateEmptyValueForNullUndefined(initEnglishProficiencyDetails);
    updateEmptyValueForNullUndefined(crntEnglishProficiencyDetails);

    return initEnglishProficiencyDetails.TestTypeCode === crntEnglishProficiencyDetails.TestTypeCode
        && initEnglishProficiencyDetails.HasTakenTest === crntEnglishProficiencyDetails.HasTakenTest
        && initEnglishProficiencyDetails.DateTaken === crntEnglishProficiencyDetails.DateTaken
        && initEnglishProficiencyDetails.ListeningScore === crntEnglishProficiencyDetails.ListeningScore
        && initEnglishProficiencyDetails.ReadingScore === crntEnglishProficiencyDetails.ReadingScore
        && initEnglishProficiencyDetails.WritingScore === crntEnglishProficiencyDetails.WritingScore
        && initEnglishProficiencyDetails.SpeakingScore === crntEnglishProficiencyDetails.SpeakingScore
        && initEnglishProficiencyDetails.VocabularyScore === crntEnglishProficiencyDetails.VocabularyScore
        && initEnglishProficiencyDetails.TotalScore === crntEnglishProficiencyDetails.TotalScore
        && initEnglishProficiencyDetails.OtherTestName === crntEnglishProficiencyDetails.OtherTestName
        && initEnglishProficiencyDetails.SpeaksEnglishAtHome === crntEnglishProficiencyDetails.SpeaksEnglishAtHome;
};

export const compareApplicationAgentDetails = (initialAgentDetails: ApplicationAgentDetails, currentAgentDetails: ApplicationAgentDetails): boolean => {
    const initAgentDetails = {...initialAgentDetails};
    const crntAgentDetails = {...currentAgentDetails};

    updateEmptyValueForNullUndefined(initAgentDetails);
    updateEmptyValueForNullUndefined(crntAgentDetails);

    return initAgentDetails.GivenName === crntAgentDetails.GivenName
        && initAgentDetails.FamilyName === crntAgentDetails.FamilyName
        && initAgentDetails.PhoneCountryCode === crntAgentDetails.PhoneCountryCode
        && initAgentDetails.PhoneNumber === crntAgentDetails.PhoneNumber
        && initAgentDetails.EmailAddress === crntAgentDetails.EmailAddress
        && initAgentDetails.AdditionalInformation === crntAgentDetails.AdditionalInformation;
}

export const compareSpecialCircumstances = (initialSpecialCircumstances: SpecialCircumstances,
                                            currentSpecialCircumstances: SpecialCircumstances): boolean => {

    const initSpecialCircumstances = { ...initialSpecialCircumstances };
    const crntSpecialCircumstances = { ...currentSpecialCircumstances };

    updateEmptyValueForNullUndefined(initSpecialCircumstances);
    updateEmptyValueForNullUndefined(crntSpecialCircumstances);

    return initSpecialCircumstances.HadCovid19Vaccination === crntSpecialCircumstances.HadCovid19Vaccination
    && compareCommaSeparatedListStrings(initSpecialCircumstances.Covid19VaccinesTaken, crntSpecialCircumstances.Covid19VaccinesTaken)
    && initSpecialCircumstances.DisabledDescription === crntSpecialCircumstances.DisabledDescription
    && initSpecialCircumstances.HadViolentBehaviour === crntSpecialCircumstances.HadViolentBehaviour
    && initSpecialCircumstances.HasMedicalHistory === crntSpecialCircumstances.HasMedicalHistory
    && initSpecialCircumstances.HospitalisedDescription === crntSpecialCircumstances.HospitalisedDescription
    && initSpecialCircumstances.InvolvedInOtherIncidentsOutsideSchool === crntSpecialCircumstances.InvolvedInOtherIncidentsOutsideSchool
    && initSpecialCircumstances.IsDisabled === crntSpecialCircumstances.IsDisabled
    && initSpecialCircumstances.MedicalHistoryDescription === crntSpecialCircumstances.MedicalHistoryDescription
    && initSpecialCircumstances.OtherIncidentsDescription === crntSpecialCircumstances.OtherIncidentsDescription
    && initSpecialCircumstances.SuspensionDueToIllegalDrugs === crntSpecialCircumstances.SuspensionDueToIllegalDrugs
    && initSpecialCircumstances.SuspensionDueToViolenceAtSchool === crntSpecialCircumstances.SuspensionDueToViolenceAtSchool
    && initSpecialCircumstances.SuspensionDueToViolenceToPerson === crntSpecialCircumstances.SuspensionDueToViolenceToPerson
    && initSpecialCircumstances.SuspensionDueToWeaponPossession === crntSpecialCircumstances.SuspensionDueToWeaponPossession
    && initSpecialCircumstances.SuspendedDueToOtherReason === crntSpecialCircumstances.SuspendedDueToOtherReason
    && initSpecialCircumstances.OtherReasonForSuspension === crntSpecialCircumstances.OtherReasonForSuspension
    && initSpecialCircumstances.ViolentBehaviourDescription === crntSpecialCircumstances.ViolentBehaviourDescription
    && initSpecialCircumstances.WasHospitalised === crntSpecialCircumstances.WasHospitalised
    && initSpecialCircumstances.WasSuspended === crntSpecialCircumstances.WasSuspended;

};

export const compareCommaSeparatedListStrings = (a: string, b: string): boolean => {
    if ((!!a && !b) || (!a && !!b)) {
        return false;
    }

    if (!a && !b) {
        return true;
    }

    let aItems = a.split(',');
    aItems.sort();

    let bItems = b.split(',');
    bItems.sort();

    return aItems.join(',') === bItems.join(',');
}

export const compareDefaultCorrespondents = (initialDefaultCorrespondent: DefaultCorrespondent,
                                            currentDefaultCorrespondent: DefaultCorrespondent): boolean  => {

   const initDefaultCorrespondent = { ...initialDefaultCorrespondent };
   const crntDefaultCorrespondent  = { ...currentDefaultCorrespondent };

   updateEmptyValueForNullUndefined(initDefaultCorrespondent);
   updateEmptyValueForNullUndefined(crntDefaultCorrespondent);

   return initDefaultCorrespondent.CorrespondentId === crntDefaultCorrespondent.CorrespondentId
          && initDefaultCorrespondent.IsAgent === crntDefaultCorrespondent.IsAgent;

};

// function updateEmptyValueForNullUndefinedForAllArguments() {

//     const args = Array.from(arguments);
//     for (const arg of args) {
//         updateEmptyValueForNullUndefined(arg);
//     }
// }

const updateEmptyValueForNullUndefined = (obj: Object) => {
    for (const property of Object.keys(obj)) {
        if (obj[property] === null || obj[property] === undefined) {
            obj[property] = '';
        }
    }
};

const initUndefinedForObject = (obj: Object) => {
    for (const property of Object.keys(obj)) {
        obj[property] = undefined;
    }
};


export const updateEmptyValuesForNullUndefined = (obj: Object) => {

    for (const property of Object.keys(obj)) {

        if (obj[property] !== null && obj[property] !== undefined && typeof obj[property] === 'object') {
            updateEmptyValuesForNullUndefined(obj[property]);
        }

        if (obj[property] === null || obj[property] === undefined) {
            obj[property] = '';
        }
    }
};



